import { SEOSegmentationFilterInput, SEOSeniorCareSubServices } from '@/__generated__/globalTypes';
import { Filters as AmplitudeFiltersType } from '@/lib/analyticsHelper';

const ALZHEIMERS_DEMENTIA_EXPERIENCE = 'ALZHEIMERS_DEMENTIA_EXPERIENCE';
const CERTIFIED_NURSING_ASSISTANT = 'CERTIFIED_NURSING_ASSISTANT';
const SENIOR_CARE_CPR_TRAINED = 'SENIOR_CARE_CPR_TRAINED';
const HOME_HEALTH_AIDE = 'HOME_HEALTH_AIDE';
const REGISTERED_NURSE = 'REGISTERED_NURSE';
const COMFORTABLE_WITH_PETS = 'COMFORTABLE_WITH_PETS';
const HAS_CAR = 'HAS_CAR';
const NON_SMOKER = 'NON_SMOKER';

const getAmplitudeFilters = (
  filters: SEOSegmentationFilterInput,
  vertical: string
): AmplitudeFiltersType => {
  const amplitudeFilters: AmplitudeFiltersType = {
    feature_name: 'Filters Applied',
  };
  const preferencesList = [];
  const professionalSkillsList = [];

  switch (vertical) {
    case 'SENIOR_CARE':
      // set 'can_help_with'
      if (filters?.seniorCareSubServices?.includes(SEOSeniorCareSubServices.DEMENTIA)) {
        // Remove 'Dementia' from 'can_help_with'
        const canHelpWith = filters.seniorCareSubServices.slice();
        const index = canHelpWith.indexOf(SEOSeniorCareSubServices.DEMENTIA);
        canHelpWith.splice(index, 1);

        // Add 'Alzheimers/Dementia experience' to 'professionalSkillsList'
        professionalSkillsList.push(ALZHEIMERS_DEMENTIA_EXPERIENCE);
        if (canHelpWith.length > 0) {
          amplitudeFilters.can_help_with = canHelpWith.join(', ');
        }
      } else if (filters?.seniorCareSubServices && filters.seniorCareSubServices.length > 0) {
        amplitudeFilters.can_help_with = filters.seniorCareSubServices.join(', ');
      }

      // set 'professional_skills' for Senior Care vertical
      if (filters?.certifiedNursingAssistant) {
        professionalSkillsList.push(CERTIFIED_NURSING_ASSISTANT);
      }
      if (filters?.seniorCareCprTrained) {
        professionalSkillsList.push(SENIOR_CARE_CPR_TRAINED);
      }
      if (filters?.homeHealthAid) {
        professionalSkillsList.push(HOME_HEALTH_AIDE);
      }
      if (filters?.registeredNurse) {
        professionalSkillsList.push(REGISTERED_NURSE);
      }
      if (professionalSkillsList.length > 0) {
        amplitudeFilters.professional_skills = professionalSkillsList.join(', ');
      }
      break;
    case 'CHILD_CARE':
      // set 'number_of_children'
      if (filters?.numberOfChildren) {
        amplitudeFilters.number_of_children = filters.numberOfChildren;
      }

      // set 'child_age_ranges'
      if (filters?.childCareAgeGroups && filters.childCareAgeGroups.length > 0) {
        amplitudeFilters.child_age_ranges = filters.childCareAgeGroups.join(', ');
      }

      // set 'professional_skills' for Child Care vertical
      if (filters?.childCareQualifications && filters.childCareQualifications.length > 0) {
        amplitudeFilters.professional_skills = filters.childCareQualifications.join(', ');
      }
      break;
    case 'HOME_CARE':
      // set 'can_help_with' for Home Care vertical
      if (filters?.housekeepingSubServices) {
        amplitudeFilters.can_help_with = filters.housekeepingSubServices.join(', ');
      }
      break;
    default:
    // do nothing
  }

  // set 'min_rate' and 'max_rate'
  if (filters?.hourlyRate) {
    const [minHourlyRate, maxHourlyRate] = filters.hourlyRate.split('-');
    amplitudeFilters.min_rate = Number(minHourlyRate);
    amplitudeFilters.max_rate = Number(maxHourlyRate);
  }

  // set 'preferences' for Senior Care and Child Care verticals
  if (filters?.comfortableWithPets) {
    preferencesList.push(COMFORTABLE_WITH_PETS);
  }
  if (filters?.hasCar) {
    preferencesList.push(HAS_CAR);
  }
  if (filters?.nonSmoker) {
    preferencesList.push(NON_SMOKER);
  }
  if (preferencesList.length > 0) {
    amplitudeFilters.preferences = preferencesList.join(', ');
  }

  // set 'languages_spoken'
  if (filters?.languages && filters.languages.length > 0) {
    amplitudeFilters.languages_spoken = filters.languages.join(', ');
  }

  return amplitudeFilters;
};

export { getAmplitudeFilters };
